import { IKeyStringAndValue, IOptions } from "../components/types/Types";

function filterData(
  data: Array<IKeyStringAndValue>,
  filters: Array<IOptions>,
  options: IKeyStringAndValue
) {
  function equalsFilter(
    filter: { filter: string; label: string },
    item: IKeyStringAndValue,
    options: IKeyStringAndValue
  ) {
    if (
      !(filter.filter in options) ||
      options[filter.filter as keyof IKeyStringAndValue] === "default"
    ) {
      return false;
    } else if (
      item[filter.filter as keyof IKeyStringAndValue] ===
      options[filter.filter as keyof IKeyStringAndValue]
    ) {
      return false;
    } else {
      return filter.filter in item;
    }
  }
  function includesFilter(
    filter: { filter: string; label: string },
    item: IKeyStringAndValue,
    options: IKeyStringAndValue
  ) {
    if (!(filter.filter in options)) {
      return false;
    } else if (
      item[filter.filter as keyof IKeyStringAndValue]
        .toLowerCase()
        .trim()
        .replace(/[^a-zA-Z0-9]/g, "")
        .includes(
          options[filter.filter as keyof IKeyStringAndValue]
            ?.toLowerCase()
            .trim()
            .replace(/[^a-zA-Z0-9]/g, "") as string
        )
    ) {
      return false;
    } else {
      return filter.filter in item;
    }
  }

  function isWithin(start: number, end: number, value: number) {
    return value >= start && value <= end;
  }
  let startValue = 0;
  function rangeStartFilter(
    filter: { filter: string; label: string },
    item: IKeyStringAndValue,
    options: IKeyStringAndValue
  ) {
    if (
      !(filter.filter in options) ||
      options[filter.filter as keyof IKeyStringAndValue] === "default"
    ) {
      startValue = 0;
      return false;
    } else {
      startValue = parseFloat(
        options?.[filter.filter as keyof IKeyStringAndValue]
      );
      const itemValue = parseFloat(
        item[filter.filter as keyof IKeyStringAndValue]
      );
      return startValue <= itemValue ? false : true;
    }
  }
  let endValue = Infinity;
  function rangeEndFilter(
    filter: { filter: string; label: string },
    item: IKeyStringAndValue,
    options: IKeyStringAndValue
  ) {
    if (
      !(filter.filter in options) ||
      options[filter.filter as keyof IKeyStringAndValue] === "default"
    ) {
      endValue = Infinity;
      return false;
    } else {
      endValue = parseFloat(
        options?.[filter.filter as keyof IKeyStringAndValue]
      );
      const itemValue = parseFloat(
        item[filter.filter as keyof IKeyStringAndValue]
      );
      return endValue >= itemValue ? false : true;
    }
  }

  function inRangeFilter(
    filter: { filter: string; label: string },
    item: IKeyStringAndValue,
    options: IKeyStringAndValue
  ) {
    if (
      !(filter.filter in options) ||
      options[filter.filter as keyof IKeyStringAndValue] === "default"
    ) {
      return false;
    } else {
      const startValue = parseFloat(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        options?.[filter.filter as keyof IKeyStringAndValue].match(/\d+/g)![0]
      );
      const endValue = parseFloat(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        options?.[filter.filter as keyof IKeyStringAndValue].match(/\d+/g)![1]
      );
      const itemValue = parseFloat(
        item[filter.filter as keyof IKeyStringAndValue]
      );
      return !isWithin(startValue, endValue ? endValue : Infinity, itemValue);
    }
  }

  interface IFilterType {
    filtered: boolean;
    filter: { key: string; label: string };
    item: IKeyStringAndValue;
  }
  const includes = ({ filtered, filter, item }: IFilterType) => {
    return !filtered &&
      includesFilter({ filter: filter.key, label: filter.label }, item, options)
      ? (filtered = true)
      : filtered;
  };
  const rangeStart = ({ filtered, filter, item }: IFilterType) => {
    return !filtered &&
      rangeStartFilter(
        { filter: filter.key, label: filter.label },
        item,
        options
      )
      ? (filtered = true)
      : filtered;
  };
  const rangeEnd = ({ filtered, filter, item }: IFilterType) => {
    return !filtered &&
      rangeEndFilter({ filter: filter.key, label: filter.label }, item, options)
      ? (filtered = true)
      : filtered;
  };
  const inRange = ({ filtered, filter, item }: IFilterType) => {
    return !filtered &&
      inRangeFilter({ filter: filter.key, label: filter.label }, item, options)
      ? (filtered = true)
      : filtered;
  };
  const equals = ({ filtered, filter, item }: IFilterType) => {
    return !filtered &&
      equalsFilter({ filter: filter.key, label: filter.label }, item, options)
      ? (filtered = true)
      : filtered;
  };
  const setFilter: {
    [key: string]: ({ filtered, filter, item }: IFilterType) => boolean;
  } = {
    omraden: includes,
    model_version: includes,
    mda_start: rangeStart,
    mda_end: rangeEnd,
    traction_weight: inRange,
    spacegrade: inRange,
    spacegrade_min: inRange,
    spacegrade_max: inRange,
    maxload: inRange,
    markeffekt: inRange,
  };

  return data.reduce(
    (acc: Array<IKeyStringAndValue>, item: IKeyStringAndValue) => {
      const isFiltered = filters.reduce((filtered, filter) => {
        if (typeof filter.filter !== "undefined") {
          return (
            setFilter[filter.key]?.({ filtered, filter, item }) ??
            equals({ filtered, filter, item })
          );
        }
        return filtered;
      }, false);

      if (!isFiltered) {
        acc.push(item);
      }
      return acc;
    },
    []
  );
}

export default filterData;
